const StripeIcon = ({ className }) => {
    return (
        <img
            className={className}
            alt="Stripe"
            src="https://images.ctfassets.net/fzn2n1nzq965/6XFEUA9FzMBMphYdcUab19/37a1e07201366a351f7956560ccac09d/Stripe_wordmark_-_slate.svg?q=80&w=1082"
        />
    );
}

export default StripeIcon;
